// Screen 5, Data Quality (SPEC §8 Screen 5; J-064). The year and ACO come from the shell's selectors
// in the URL.
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { metadataQueryOptions } from "@/features/aco-shell/api/metadata";
import { ShellStatusMessage } from "@/features/aco-shell/components/shell-status-message";
import { ALL_ACOS, resolveYear } from "@/features/aco-shell/default-aco";
import { shellStatus } from "@/features/aco-shell/shell-status";
import { DataQualityScreen } from "@/features/aco-data-quality/components/data-quality-screen";

export const Route = createFileRoute("/_authenticated/data-quality")({
  // The shell draws the permission state for a role or account the checks' read refuses (J-209).
  staticData: { screenName: "Data Quality", requires: { acoQuality: ["read"] } },
  component: DataQualityPage,
});

function DataQualityPage() {
  const search = Route.useSearch();
  const metadata = useQuery(metadataQueryOptions());
  // J-209 (inbox 06 PR D items 7 and 12): a failed or refused read says so; the year defaults to the
  // newest with results, as the shell's selector does.
  const status = shellStatus(metadata);
  if (status !== "ready")
    return <ShellStatusMessage status={status} onRetry={() => void metadata.refetch()} />;
  const year = resolveYear(metadata.data, search.year, search.aco);
  if (year === undefined)
    return <p className="text-muted-foreground text-sm">No performance year is configured.</p>;
  return <DataQualityScreen year={year} aco={search.aco === ALL_ACOS ? undefined : search.aco} />;
}
